import React from 'react';
import { Link, NavLink } from 'react-router-dom';

// Components
import Social from './Social';
import CtaBtn from './CtaBtn';

// Assets
import navGoatImg from '../assets/logo/goatnoleftborder.svg';

const Navbar = (props) => {
    const styleMobile = {
        display: props.displayMobile
    }
    return (
    <header>
    <div className="navbarLogo">
        <img src={navGoatImg} alt="Candid Goat Logo" /> 
        <h2 className="fancyFont">Candid Goat</h2>
    </div>
    <div className="mobileMenu flexColumn">
        <button className="button smallFont fancyFont turnWhite" onClick={props.mobileMenu} >&#9776;</button>
        <div style={styleMobile} className="mobileLinks flexColumn fancyFont turnBlack">
            <Link to="/" className="navLink turnBlack">Home</Link>
            <Link to="/about" className="navLink turnBlack">About</Link>
            <Link to="/services" className="navLink turnBlack">Services</Link>
            <Social />
        </div>
    </div>
    <nav className="navbar flexRow noPadding">
        <div className="whiteNavbar flexRow flexStart fancyFont width-6">
            <div className="navLink-container width-4">
                <Link to="/" className="navLink turnWhite">Home</Link>
            </div>
            <div className="navLink-container width-4">
                <NavLink to="/about" activeClassName="bolder" className="navLink turnWhite">About</NavLink>
            </div>
            <div className="navLink-container width-4">
                <NavLink to="/services" activeClassName="bolder" className="navLink turnWhite">Services</NavLink>
            </div>
            {/* <div className="navLink-container">
                <a href="/blog" className="navLink">Blog</a>
            </div> */}
        </div>
        <div className="blackNavbar flexRow flexEnd subTitleFont width-6">
            <Social/>
            <CtaBtn click={props.click} name="let's talk" classes="fancyFont bolder"/>
        </div>
    </nav>
    </header>
)};

export default Navbar;


// WEBPACK FOOTER //
// ./src/components/Navbar.js